"use strict";

(function () {
  var bottomMenuForm = document.querySelector(".p-bottomMenuForm");
  var formNote = document.querySelector("#contact-form .p-form__note");

  if (!bottomMenuForm || !formNote || !("IntersectionObserver" in window)) return;

  var isNoteVisible = false;

  var setVisible = function (show) {
    bottomMenuForm.classList.toggle("-is-visible", show);
    bottomMenuForm.setAttribute("aria-hidden", show ? "false" : "true");
  };

  var update = function () {
    setVisible(!isNoteVisible);
  };

  var observer = new IntersectionObserver(
    function (entries) {
      isNoteVisible = entries[0].isIntersecting;
      update();
    },
    {
      root: null,
      threshold: 0,
    }
  );

  observer.observe(formNote);
  update();
})();
